import React from 'react';

const Vue_Component_Instance_el = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_el Component</h1>
      <p>This is the Vue_Component_Instance_el tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_el;
